<template>
  <div class="w-100 mt-5 d-flex justify-content-center align-items-center">
    <div class="col-md-6 col-lg-4">
      <div class="card card-body">

        <div v-if="passwordReset">
          <h4 class="p-0 m-0">{{ $t('phrase.reset_password') }}</h4>
          <div class="text-muted mb-3">
            {{ $t('sentence.reset_password') }}
          </div>

          <form method="post" @submit.prevent="resetPassword">
            <div class="mb-3">
              <v-text-input
                id="reset-password-new-password-1"
                label="word.password"
                type="password"
                v-model="formData.password1"
                :required="true"
                :errors="errors.password1"
              />
            </div>

            <div class="mb-3">
              <v-text-input
                id="reset-password-new-password-2"
                label="word.password_repeat"
                type="password"
                v-model="formData.password2"
                :required="true"
                :errors="errors.password2"
              />
            </div>

            <v-form-errors
              :errors="errors.non_field_errors"
            />

            <div class="d-flex justify-content-end">
              <v-button
                id="reset-password-submit"
                text="word.save"
                type="submit"
                :loader="loader"
              />
            </div>
          </form>
        </div>
        <div v-else-if="fetchFailed">
          <h2>
            {{ $t('phrase.invalid_link') }}
          </h2>
          <p class="text-muted">
            {{ $t('sentence.invalid_password_link') }}
          </p>
          <div class="d-flex justify-content-end">
            <v-button
              text="phrase.try_again"
              :route-to="{name: 'login', query: {fpmode: 'true'}}"
            />
          </div>
        </div>

        <v-loader
          :small="true"
          v-else
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import FormErrors from '@/common/components/FormErrors.vue';
import Loader from '@/common/components/Loader.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import api from '@/common/api';
import { notify } from '@/common/utils/notify';

export default {
  name: 'ResetPassword',
  components: {
    'v-button': Button,
    'v-form-errors': FormErrors,
    'v-text-input': TextInput,
    'v-loader': Loader,
  },
  data() {
    return {
      formData: {
        password1: '',
        password2: '',
      },
      errors: {},
      loader: {
        loading: false,
      },
      passwordReset: null,
      fetchFailed: false,
    };
  },
  methods: {
    async resetPassword() {
      this.loader.loading = true;
      const response = await api.patch(`password-resets/${this.$route.params.uuid}/`, this.formData);
      if (response.status === 400) {
        this.errors = response.data;
        this.loader.loading = false;
        return;
      }

      notify('word.success', 'sentence.reset_password_success');
      await this.$router.push({ name: 'login' });
      this.loader.loading = false;
    },
    async fetchPasswordReset() {
      const response = await api.get(`password-resets/${this.$route.params.uuid}/`);
      if (response.status !== 200) {
        this.fetchFailed = true;
      }
      this.passwordReset = response.data;
    },
  },
  created() {
    this.fetchPasswordReset();
  },
};
</script>
